module.exports = __webpack_public_path__ + "img/Y.2236a85a.png";